import {
  NBS_API_GET_SUBSCRIPTIONS_LIST_REQUEST,
  NBS_API_GET_SUBSCRIPTIONS_LIST_SUCCESS,
  NBS_API_GET_SUBSCRIPTIONS_LIST_FAILURE
} from '../../constants/actions';

import nbsApi from '../../assets/helpers/nbsApi';
import strings from '../../assets/localization';

function nbsApiGetSubscriptionsListRequest () {
  return { type: NBS_API_GET_SUBSCRIPTIONS_LIST_REQUEST };
}
function nbsApiGetSubscriptionsListSuccess (response) {
  return {
    type: NBS_API_GET_SUBSCRIPTIONS_LIST_SUCCESS,
    response
  };
}
function nbsApiGetSubscriptionsListError (error) {
  return {
    type: NBS_API_GET_SUBSCRIPTIONS_LIST_FAILURE,
    error: error.cause || error
  };
}
export function nbsApiGetSubscriptionsList (data) {
  const url = 'getSubscriptionsList';
  if (!data.language) {
    data.language = strings.getLanguage();
  }
  return dispatch => {
    dispatch(nbsApiGetSubscriptionsListRequest());
    return nbsApi(url, data)
      .then(response => dispatch(nbsApiGetSubscriptionsListSuccess(response)))
      .catch(error => dispatch(nbsApiGetSubscriptionsListError(error)));
  };
}
